import { render } from "./PublicationCard.vue?vue&type=template&id=e21b48ee&ts=true&lang=pug"
import script from "./PublicationCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./PublicationCard.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__